import { Drillable } from "./Drillable";

export function KpiCard({ label, value, sub, status, progress, module, seed, testId }) {
  const body = (
    <div className="kpi-card h-full" data-testid={testId}>
      {status && <span className={`pill ${status} absolute top-4 right-4`}>{status === "pass" ? "PASS" : status === "watch" ? "WATCH" : "MISS"}</span>}
      <div className="text-[11px] uppercase tracking-widest font-bold" style={{ color: "var(--slate)" }}>{label}</div>
      <div className="text-3xl font-black mt-2 num" style={{ color: "var(--navy)", fontFamily: "Chivo" }}>{value}</div>
      {sub && <div className="text-xs mt-1" style={{ color: "var(--slate)" }}>{sub}</div>}
      {progress != null && (
        <div className="progress-track">
          <div className="progress-fill" style={{ width: `${Math.min(100, progress * 100)}%` }} />
        </div>
      )}
    </div>
  );
  if (!module) return body;
  return (
    <Drillable module={module} seed={seed || []} testId={`drill-${testId}`}>
      {body}
    </Drillable>
  );
}
